import React, { useState } from 'react'
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography
} from '@mui/material'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Klodka } from './Klodka'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

const Login = () => {
  const [countryCode, setCountryCode] = useState('+48')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const navigate = useNavigate()

  const handleInputChange = e => {
    const { name, value } = e.target
    if (name === 'password') {
      setPassword(value)
    }
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword(prev => !prev)
  }

  const handleLogin = async () => {
    try {
      const fullPhoneNumber = countryCode + phoneNumber
      const loginData = {
        username: fullPhoneNumber,
        password: password
      }

      console.log('Wysyłanie danych logowania:', loginData)

      const loginResponse = await axios.post(process.env.REACT_APP_API_URL + '/loyalty/login', loginData)

      console.log('Odpowiedź serwera:', loginResponse.data)

      if (loginResponse.data.success || loginResponse.data.token) {
        localStorage.setItem('token', loginResponse.data.token)
        navigate('/restauracji')
      } else {
        if (loginResponse.data.code === 401 && loginResponse.data.message === 'Username could not be found.') {
          setErrorMessage('Niepoprawne wprowadzone dane')
        } else {
          setErrorMessage('Niepoprawnie wprowadzone dane')
        }
        console.error('Błąd logowania:', loginResponse.data)
      }
    } catch (error) {
      console.error('Błąd podczas logowania:', error.message)
      setErrorMessage('Wystąpił błąd podczas logowania')
    }
  }

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#00A3FF1F',
    marginTop: '-50px'
  }

  const textFieldStyle = {
    borderRadius: '20px',
    width: '70%',
    margin: '10px'
  }

  const buttonStyle = {
    borderRadius: '15px',
    background: '#3FC500',
    color: 'white',
    width: '150px',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: '700',
    marginTop: '20px',
    boxShadow: 'none'
  }

  return (
    <div style={containerStyle}>
      <Klodka />

      <FormControl variant='outlined' style={textFieldStyle}>
        <InputLabel>Kod kraju</InputLabel>
        <Select label='Kod kraju' value={countryCode} onChange={e => setCountryCode(e.target.value)}>
          <MenuItem value='+48'>+48 (Polska)</MenuItem>
          <MenuItem value='+420'>+420 (Czechy)</MenuItem>
          <MenuItem value='+380'>+380 (Ukraina)</MenuItem>
          <MenuItem value='+1'>+1 (USA)</MenuItem>
        </Select>
      </FormControl>
      <TextField
        name='phone'
        label='Numer telefonu'
        variant='outlined'
        value={phoneNumber}
        onChange={e => setPhoneNumber(e.target.value)}
        fullWidth
        margin='normal'
        style={textFieldStyle}
      />
      <TextField
        name='password'
        label='Hasło'
        type={showPassword ? 'text' : 'password'}
        variant='outlined'
        value={password}
        onChange={handleInputChange}
        fullWidth
        margin='normal'
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={handleTogglePasswordVisibility} edge='end'>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }}
        style={textFieldStyle}
      />
      {errorMessage && (
        <Typography variant='body2' color='error' style={{ marginTop: '10px' }}>
          {errorMessage}
        </Typography>
      )}
      <Button variant='contained' onClick={handleLogin} style={buttonStyle}>
        Zaloguj
      </Button>
    </div>
  )
}

export default Login
